import PropTypes from 'prop-types';

// Components
import Table from '@/components/pages/reports/components/Table';
import TableError from '@/components/pages/reports/components/Table/TableError';

const TableList = ({
    isLoading,
    errorReports,
    mutateReports,
    columns,
    data,
    initialState,
    requestParams,
    setRequestParams
}) => {
    if (errorReports) {
        return <TableError mutate={mutateReports} />;
    }

    return (
        <Table
            data={data}
            isLoading={isLoading}
            columns={columns}
            requestParams={requestParams}
            setRequestParams={setRequestParams}
            initialState={initialState}
        />
    );
};

TableList.propTypes = {
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    mutateReports: PropTypes.func,
    errorReports: PropTypes.object,
    requestParams: PropTypes.object,
    setRequestParams: PropTypes.func,
    columns: PropTypes.array.isRequired
};

export default TableList;
